// Утилиты для режима разработки

export const isDevelopment = () => {
  return (
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1')
  )
}

// Флаг для включения/отключения системы прав в режиме разработки
// ОТКЛЮЧЕНО: локальная система прав отключена до переноса проверок на backend
// export const PERMISSIONS_ENABLED =
//   isDevelopment() &&
//   getDevSetting('dev_permissions_enabled', true)
export const PERMISSIONS_ENABLED = false

// Флаг для показа отладочных панелей
export const DEBUG_PANELS_ENABLED =
  isDevelopment() &&
  getDevSetting('dev_debug_panels_enabled', true)

// Функция для получения настроек разработки из localStorage
function getDevSetting(key, defaultValue) {
  if (typeof window === 'undefined') return defaultValue

  const saved = localStorage.getItem(key)
  if (saved === null) return defaultValue

  try {
    return JSON.parse(saved)
  } catch {
    return defaultValue
  }
}

// Функция для проверки нужно ли использовать новую систему прав
// ОТКЛЮЧЕНО: локальная система прав отключена до переноса проверок на backend
export const shouldUseNewPermissions = () => {
  // return true  // раскомментировать когда будет защита через backend
  return false
  // if (!isDevelopment()) {
  //   return true
  // }
  // return PERMISSIONS_ENABLED
}

// Функция для проверки нужно ли показывать отладочные панели
export const shouldShowDebugPanels = () => {
  return DEBUG_PANELS_ENABLED
}
